export default __webpack_public_path__ + "static/media/cardRegisterAddress.0b418932.png";